import { InjectionToken } from '@angular/core';
import { IPioOptions } from '../core/interfaces';

export const PIO_OPTIONS = new InjectionToken<IPioOptions>('PIO_OPTIONS');
